import { render, staticRenderFns } from "./ShopVouchersBtn.vue?vue&type=template&id=213e8ed4&scoped=true&"
import script from "./ShopVouchersBtn.vue?vue&type=script&lang=js&"
export * from "./ShopVouchersBtn.vue?vue&type=script&lang=js&"
import style0 from "./ShopVouchersBtn.vue?vue&type=style&index=0&id=213e8ed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213e8ed4",
  null
  
)

export default component.exports